//  nextUntil fn based on Chris Ferdinandi's work here (MIT License), https://gomakethings.com

var nextUntil = function (elem, selector) {

  // Setup siblings array
  var siblings = [];

  // Pushes first element to array since it already matches the gridM class
  siblings.push(elem);

  // setup the next element
  var nextElem = elem.nextElementSibling;

  // As long as a sibling exists
  while (nextElem) {

    // If we've reached an element without the selector class, we break
    if (!nextElem.classList[0] || nextElem.classList[0].indexOf(selector)){
      break
    };

    // Otherwise, push it to the siblings array
    siblings.push(nextElem);

    // Get the next sibling element
    nextElem = nextElem.nextElementSibling;
  }

  return siblings;
};

function gridManager() {
  // Select grid elements in the rich text

  var gridElements =  Array.from(document.querySelectorAll('.RichText [class*="GridM-"]'))

  // for each elements, checks if it has a previous sibling (in which case we abort the loop)
  // and if not, we create a wrapper around it and its next siblings
  gridElements.forEach(function(gridElement){
    var previousSibling = gridElement.previousElementSibling

    // If previous sibling element has a class that contains 'GridM-', 
    // we return sine we don't want to create a wrapper inside another wrapper at the same level
    if(previousSibling.classList.length && previousSibling.classList[0].indexOf('GridM-') > -1){
      return
    }

    // Otherwise, we get all the next siblings that have a 'GridM-' class
    var elementsToGrid = nextUntil(gridElement, 'GridM-');

    // Get the element following the last sibling element
    var lastSibling = elementsToGrid[elementsToGrid.length - 1].nextElementSibling

    // Or the parent element
    var parentSibling = null;
    if(lastSibling === null){
      parentSibling = elementsToGrid[elementsToGrid.length - 1].parentNode
    }
    
    // Create the div wrapper element
    var wrapper = document.createElement('div');
    wrapper.setAttribute('class', 'GridM')

    // Adds the child elements into the wrapper
    Array.prototype.forEach.call((elementsToGrid), function(sibling){
      wrapper.appendChild(sibling);
    });

    // Adds the wrapper to the DOM at the correct position
    if(lastSibling !== null){
      lastSibling.parentNode.insertBefore(wrapper, lastSibling);
    } else {
      parentSibling.appendChild(wrapper);
    }
  })

}

function initGridManager(){
  var GRID_SEL = '.RichText [class*="GridM-"]';

  var element = document.querySelectorAll(GRID_SEL);
  if(element.length === 0){
      return;
  }

  gridManager();
};

initGridManager();